import { Button, Checkbox, Container, FormControlLabel, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Page from "src/components/Page";
import { SITE_ADDRESS } from "src/config";
import useSettings from "src/hooks/useSettings";
import { setRulesItem } from "src/utils/rules";

const RulesPage = () => {
    const { themeStretch } = useSettings();

    const navigate = useNavigate();

    const [AcceptRuleUser, setAcceptRuleUser] = useState(false)

    const handleChange = (event) => {
        setAcceptRuleUser(event.target.checked);
    };

    const handleAcceptRules = () => {

        if (!AcceptRuleUser) {
            toast.error("برای ادامه باید قوانین را بپذیرید!")
            return
        }

        setRulesItem();
        navigate("/")
    }


    return (
        <>
            <Page
                sx={{
                    py: 3,
                }}
                title={"صفحه قوانین"}
            >

                <Container maxWidth={themeStretch ? false : 'lg'}>

                    {/* <HeaderBreadcrumbs heading={"صفحه قوانین"} /> */}

                    <Typography sx={{ mb: 2, fontSize: 23, fontWeight: 700, textAlign: "center" }}>
                        ثبت نام اولیه عتبات دانشگاهیان 1404
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        دانشگاهیان محترم؛ <br />
                        خواهشمند است پیش از ثبت‌نام، نکات ذیل را با دقت مطالعه نموده و سپس نسبت به ثبت‌نام اقدام فرمایید.
                    </Typography>
                    <Typography sx={{ mb: 2, fontWeight: 700 }}>
                        ثبت نام و قرعه کشی :
                    </Typography>
                    <ul className="dash-" style={{ paddingRight: 16 }}>
                        <li style={{ marginBottom: 8 }}>
                            ثبت‌نام اولیه متقاضیان از تاریخ ۱۵ دی‌ماه ۱۴۰۴ آغاز و تا 30 دی‌ماه ۱۴۰۴ ادامه خواهد داشت.
                        </li>
                        <li style={{ marginBottom: 8 }}>
                            نتایج قرعه‌کشی پس از پایان ثبت نام، از طریق سامانه لبیک قابل مشاهده خواهد بود.
                        </li>
                        <li style={{ marginBottom: 8 }}>
                            اعزام دانشگاهیان به عتبات عالیات در این دوره از تاریخ 20 بهمن‌ماه ۱۴۰۴ آغاز می‌گردد.
                        </li>
                        <li style={{ marginBottom: 8 }}>
                            هر متقاضی در زمان ثبت‌نام می‌تواند حداکثر دو اولویت متفاوت برای تاریخ سفر خود انتخاب نماید.
                        </li>
                        {/* <li style={{ marginBottom: 8 }}>
                            با توجه به اینکه برای هر تاریخ اعزام، قرعه‌کشی به‌صورت مجزا انجام می‌شود، بدیهی است احتمال پذیرش در تاریخ‌هایی با تقاضای بالاتر (نظیر ایام خاص و اعیاد شعبانیه) کاهش خواهد یافت.
                        </li> */}
                    </ul>

                    <Typography sx={{ my: 1, fontWeight: 700 }}>
                        قوانین کلی ثبت نام و اعزام
                    </Typography>
                    <ul className="dash-" style={{ listStyle: "none" }}>
                        <li style={{ marginBottom: 8 }}>
                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                1.	جامعه مجاز به ثبت نام
                            </Typography>
                            کلیه دانشگاهیان اعم از دانشجویان، اعضای هیئت علمی و کارکنان محترم دانشگاه‌ها مجاز به شرکت در فرآیند ثبت‌نام عتبات دانشگاهیان می‌باشند.
                        </li>
                        <li style={{ marginBottom: 8 }}>

                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                2.	نحوه ثبت‌نام همراهان
                            </Typography>
                            دانشگاهیان می‌توانند به‌صورت انفرادی و یا در صورت تمایل، به همراه همسر و فرزندان نسبت به ثبت نام اقدام نمایند.
                            <Typography color={"error"} sx={{ mt: 0.5 }}>
                                ثبت‌نام و اعزام پدر و مادر به همراه دانشگاهیان به هیچ عنوان امکان پذیر نمی باشد.
                            </Typography>
                        </li>

                        <li style={{ marginBottom: 8 }}>
                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                3.	محل و شرایط اعزام
                            </Typography>

                            اعزام زائران از استان محل تحصیل یا محل تدریس انجام خواهد شد.
                            <br />
                            نظر به اینکه انتخاب کاروان و تاریخ اعزام توسط شخص زائر در زمان ثبت‌نام صورت می‌پذیرد، امکان جابه‌جایی کاروان یا تغییر تاریخ اعزام در مراحل بعدی وجود نخواهد داشت.

                        </li>

                        <li style={{ marginBottom: 8 }}>
                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                4.	شرایط احراز وضعیت دانشگاهی
                            </Typography>
                            <ul style={{ lineHeight: "2", paddingRight: 20 }}>
                                <li>
                                    دانشجوی متقاضی می‌بایست در زمان ثبت‌نام، اشتغال به تحصیل داشته باشد.
                                </li>
                                <li>
                                    اعضای هیئت علمی و کارکنان محترم دانشگاه‌ها ملزم به ارائه حکم کارگزینی معتبر می‌باشند.
                                </li>
                            </ul>
                        </li>

                        <li style={{ marginBottom: 8 }}>
                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                5.	سابقه تشرف قبلی
                            </Typography>

                            افرادی که پیش‌تر در قالب کاروان‌های عمره یا عتبات دانشگاهیان مشرف شده‌اند، هیچ‌گونه منعی برای ثبت‌نام و تشرف مجدد در کاروان‌های عتبات دانشگاهیان نخواهند داشت.

                        </li>

                        <li style={{ marginBottom: 8 }}>
                            <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                6.	ثبت صحیح اطلاعات هویتی و تماس
                            </Typography>

                            متقاضیان موظف‌اند در درج اطلاعات هویتی، از جمله کد ملی صحیح و معتبر و شماره تلفن همراه به نام شخص متقاضی دقت لازم را به عمل آورند.

                            <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                                <li>
                                    برای هر نفر، ثبت شماره تلفن همراه مجزا و به نام همان فرد الزامی است.
                                </li>
                                <li>
                                    پس از ثبت‌نام، امکان اصلاح اطلاعات در زمان اعزام وجود نخواهد داشت.
                                </li>
                                <li>
                                    جهت ثبت‌نام فرزندان زیر ۱۸ سال، می بایست از شماره تلفن همراه دوم والدین استفاده شود.
                                </li>
                            </ul>
                        </li>

                    </ul>

                    <Typography sx={{ my: 2, fontWeight: 700 }}>
                        هزینه و مدت سفر
                    </Typography>

                    <Typography>
                        کاروان‌های عتبات دانشگاهیان در سه قالب متفاوت و با شرایط زیر اعزام خواهند شد:
                    </Typography>

                    <div style={{ marginBottom: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            1. انواع کاروان‌ها و مدت سفر
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2", listStyleType: "none" }}>
                            <li>
                                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                    1.	هوایی – هتلی
                                </Typography>

                                <ul style={{ paddingRight: 20, marginRight: 10, }}>
                                    <li>
                                        مدت سفر: ۷ شب
                                    </li>
                                    <li>
                                        محل اسکان: هتل
                                    </li>
                                </ul>

                            </li>
                            <li>
                                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                    2.	زمینی – هتلی
                                </Typography>

                                <ul style={{ paddingRight: 20, marginRight: 10, }}>
                                    <li>
                                        مدت سفر: ۷ شب اقامت + ۲ شب در مسیر رفت و برگشت
                                    </li>
                                    <li>
                                        محل اسکان: هتل
                                    </li>
                                </ul>

                            </li>
                            <li>
                                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                    <Typography component={"span"} sx={{ fontWeight: 700 }}>
                                        3.	زمینی – حسینیه‌ای
                                    </Typography>
                                    <Typography component={"span"} color={"error"} sx={{ fontWeight: 700, mr: 0.5 }}>
                                        (فقط ویژه دانشجویان مجرد)
                                    </Typography>
                                </Typography>

                                <ul style={{ paddingRight: 20, marginRight: 10, }}>
                                    <li>
                                        مدت سفر: ۵ شب اقامت + ۲ شب در مسیر رفت و برگشت
                                    </li>
                                    <li>
                                        محل اسکان: حسینیه
                                    </li>
                                </ul>

                            </li>

                        </ul>
                    </div>

                    <Typography sx={{ lineHeight: "1.7" }}>
                        تذکر مهم: در کاروان‌های زمینی حسینیه‌ای، هزینه اسکان توسط ستاد عمره و عتبات دانشگاهیان تأمین می‌گردد و زائران صرفاً هزینه‌های حمل و نقل، تغذیه، بیمه و هلال احمر را پرداخت می‌کنند.
                        <br />
                        شایان ذکر است که کیفیت تغذیه در این نوع کاروان، مشابه کاروان‌های هتلی می‌باشد.
                        <br />
                        همچنین توجه فرمایید که اسکان در حسینیه بدون تخت بوده و این نوع اعزام تنها مختص دانشجویان پسر و دختر مجرد می‌باشد.

                    </Typography>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            2. برنامه اقامت و زیارت
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                    سفر ۷ شبه شامل:
                                </Typography>

                                <ul style={{ paddingRight: 20, marginRight: 10, }}>
                                    <li>
                                        ۳ شب نجف اشرف
                                    </li>
                                    <li>
                                        ۱ شب کاظمین (زیارت سامرا به‌صورت عبوری)
                                    </li>
                                    <li>
                                        ۳ شب کربلای معلی
                                    </li>
                                </ul>

                            </li>
                            <li>
                                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                                    سفر ۵ شبه شامل:
                                </Typography>

                                <ul style={{ paddingRight: 20, marginRight: 10, }}>
                                    <li>
                                        ۲ شب نجف اشرف
                                    </li>
                                    <li>
                                        ۱ شب کاظمین (زیارت سامرا به‌صورت عبوری)
                                    </li>
                                    <li>
                                        ۲ شب کربلای معلی
                                    </li>
                                </ul>

                            </li>

                        </ul>
                    </div>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            3. هزینه تقریبی سفر
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                کاروان هوایی – هتلی: حدود ۳۴ میلیون تومان
                            </li>
                            <li>
                                کاروان زمینی – هتلی: حدود ۱۶ میلیون تومان
                            </li>
                            <li>
                                کاروان زمینی – حسینیه‌ای: حدود ۹ میلیون تومان
                            </li>

                        </ul>
                    </div>


                    <Typography sx={{ my: 1 }}>
                        شایان ذکر است نرخ نهایی هر استان با توجه به میزان فاصله از مرزهای خروجی کشور متفاوت خواهد بود.
                    </Typography>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            4. ملاحظات مالی
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                با توجه به تأثیر نوسانات نرخ ارز بر قیمت تمام‌شده سفر، امکان تغییر هزینه‌ها در طول بازه اعزام وجود دارد.
                            </li>
                            <li>
                                قیمت کاروان نوروزی 25درصد افزایش خواهند داشت.
                            </li>
                        </ul>
                    </div>

                    <Typography sx={{ my: 1, lineHeight: "2" }}>
                        بر اساس رایزنی‌های صورت‌گرفته، تخفیف‌هایی ویژه کاروان‌های دانشجویی در نظر گرفته شده است؛ به‌گونه‌ای که هزینه این کاروان‌ها در مقایسه با کاروان‌های هم‌درجه سازمان حج و زیارت، در مجموع پایین‌تر می‌باشد.
                    </Typography>

                    <Typography sx={{ my: 2, fontWeight: 700 }}>
                        تسهیلات ویژه کاروان‌های دانشجویی
                    </Typography>

                    <Typography>
                        در راستای تسهیل بهره‌مندی دانشجویان از سفرهای زیارتی و با عنایت به پیگیری‌ها و هماهنگی‌های به‌عمل‌آمده با چند بانک عامل، امکان بهره‌مندی از تسهیلات بانکی ویژه کاروان‌های دانشجویی به شرح ذیل فراهم گردیده است:
                    </Typography>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            1. میزان تسهیلات بانکی
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                کاروان‌های هوایی: تا سقف ۲۵ میلیون تومان
                            </li>
                            <li>
                                کاروان‌های زمینی هتلی: تا سقف ۱۰ میلیون تومان
                            </li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            2. جامعه مشمولان تسهیلات
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                این تسهیلات صرفاً به دانشجویان اختصاص دارد.
                            </li>
                            <li>
                                در اعزام‌های متأهلی، تسهیلات صرفاً به دانشجو و همسر ایشان تعلق می‌گیرد.
                            </li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            3. کاروان‌های زمینی – حسینیه‌ای
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                دانشجویان متقاضی اعزام در قالب کاروان‌های زمینی حسینیه‌ای می‌توانند مطابق ضوابط مربوطه از تسهیلات صندوق رفاه دانشگاه محل تحصیل خود استفاده نمایند.
                            </li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            4. زمان و نحوه پرداخت تسهیلات
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                پرداخت تسهیلات پس از واریز کامل هزینه سفر و احراز قطعی بودن اعزام هر زائر انجام خواهد شد.
                            </li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: 8, marginTop: 8 }}>
                        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>
                            5. تذکر مهم
                        </Typography>

                        <ul style={{ paddingRight: 20, marginRight: 20, marginTop: 10, lineHeight: "2" }}>
                            <li>
                                تسهیلات بانکی مذکور منحصراً ویژه دانشجویان می‌باشد.
                            </li>
                            <li>
                                کارمندان و اعضای هیئت علمی دانشگاه‌ها صرفاً در صورت وجود سرفصل «تسهیلات زیارت» در صندوق رفاه دانشگاه متبوع خود، امکان بهره‌مندی از تسهیلات مربوطه را خواهند داشت.
                            </li>
                        </ul>
                    </div>


                    <Typography sx={{ my: 2, fontWeight: 700 }}>
                        مزایای اعزام در قالب عتبات دانشگاهیان
                    </Typography>

                    <ul style={{ paddingRight: 20, marginTop: 10, lineHeight: "2" }}>
                        <li>
                            حضور صرفاً دانشگاهیان در هر کاروان و بهره‌مندی از فضای متناسب با جامعه دانشگاهی
                        </li>
                        <li>
                            برگزاری برنامه‌های فرهنگی ویژه دانشگاهیان در طول سفر
                        </li>
                        <li>
                            امکان بهره‌مندی از تسهیلات قرض‌الحسنه وفق ضوابط مربوطه
                        </li>
                        <li>
                            اعطای پکیج فرهنگی ویژه زائران دانشگاهی
                        </li>
                        <li>
                            سهولت در اخذ مجوز خروج از کشور برای مشمولین خدمت وظیفه عمومی
                            (بدون نیاز به تودیع وثیقه ده میلیون تومانی)
                        </li>
                    </ul>


                    <Typography sx={{ my: 2, fontWeight: 700 }} color={"error"}>
                        تذکر مهم
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        برای ارتباط با ستاد عمره و عتبات دانشگاهیان و طرح مطالب و مسائل خود تنها از طریق پایگاه اطلاع رسانی لبیک و بخش ارتباط با ما اقدام نمایید و تا حدامکان از تماس تلفنی و مراجعه حضوری خودداری نمایید. همچنین جهت اطلاع از آخرین اخبار ثبت نام تا اعزام عمره دانشگاهیان ما را در شبکه های اجتماعی ایتا ، سروش، تلگرام با آیدی :  @labbayk_ir دنبال کنید.
                    </Typography>
                    <Typography component={"a"} href={`${SITE_ADDRESS}/faq`} target="_blank" sx={{ mb: 2 }} color={"blue"}>
                        پاسخ به پرسش های متداول
                    </Typography>




                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} mt={3}>
                        <FormControlLabel
                            control={<Checkbox color="success" onChange={handleChange} checked={AcceptRuleUser} />}
                            label="قوانین را میپذیرم"
                            labelPlacement="end"
                        />

                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleAcceptRules}
                        >
                            ادامه
                        </Button>

                    </Stack>



                </Container>

            </Page>
        </>
    );
}

export default RulesPage;